module.exports = __webpack_public_path__ + "img/pizzaset-816.bb4c78ca.png";